class HtmlCompile {
  constructor($compile, $timeout, $rootScope, $templateCache) {
    this.restrict = 'A';
    this.$compile = $compile;
    this.$timeout = $timeout;
    this.link = this.htmlCompileLink;

    this.$rootScope = $rootScope;
    this.$templateCache = $templateCache;
  }

  htmlCompileLink(scope, element, attrs) {
    scope.$watch(attrs.ngHtmlCompile, newValue => {
      element.html(newValue);
      const { main, outerItem, items } = attrs;
      if (main) {
        scope.main = JSON.parse(main);
      }
      if (items) {
        scope.items = JSON.parse(items);
      }
      if (outerItem) {
        scope.outerItem = JSON.parse(outerItem);
      }

      this.$compile(element.contents())(scope);
    });
  }
}

export default /* @ngInject */ (
  $compile,
  $timeout,
  $rootScope,
  $templateCache
) => new HtmlCompile($compile, $timeout, $rootScope, $templateCache);
